import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSketchbook: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconSketchbook"><Path fillRule="evenodd" clipRule="evenodd" d="M3.5 2.5H20.5V21.5H3.5V2.5ZM8 7H16V8.5H8V7ZM8 11H13V12.5H8V11Z" fill="currentColor"/></CentralIconBase>;
});

export default IconSketchbook;
